import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const postAdditionalDepartments = (body) =>
  requestsTemplates.post(mainPath, `/employee/department/`,body);
